import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { Form, Segment, Button, Message, Icon } from "semantic-ui-react";
import { estiloSegmento } from "../../../estilos/segmentos";
import { isMobile } from "react-device-detect";
import { DispositivoMovilNoDetectado } from "../../Public/DispositivoMovilNoDetectado";
import { MetodoPago } from "../../../componentes/NuevoViaje";
import { CalcularTrayecto } from "../../../componentes/NuevoViaje/CalcularTrayecto";
import { VerResumen } from "../../../componentes/NuevoViaje/VerResumen";
import { apiSubastador } from "../../../api/subastador";
import { apiPrecio } from "../../../api/precio";
import { apiUsuario } from "../../../api/usuario";
import { apiViaje } from "../../../api/viaje";
import { apiMobbex } from "../../../api/mobbex";
import {
  getIdioma,
  getemail,
  getpassword,
  setmenuAbajoSeleccionado,
  setmenuLateralSeleccionado,
  getNombre,
  getApellido,
  getid,
  getTokenNotificacion,
  setPoolingActivado,
  setViajeId,
} from "../../../utils/variablesLocales";
import Swal from "sweetalert2";
import { estiloColores } from "../../../estilos/colores";
import { ENTORNO } from "../../../utils/constantes";
import CssBaseline from "@mui/material/CssBaseline";
import AppBar from "@mui/material/AppBar";
import Toolbar from "@mui/material/Toolbar";
import Container from "@mui/material/Container";
import IconButton from "@mui/material/IconButton";
import CloseIcon from "@mui/icons-material/Close";
import Box from "@mui/material/Box";
import Fab from "@mui/material/Fab";
import useScrollTrigger from "@mui/material/useScrollTrigger";
import Fade from "@mui/material/Fade";
import PropTypes from "prop-types";
import Typography from "@mui/material/Typography";
import KeyboardArrowUpIcon from "@mui/icons-material/KeyboardArrowUp";
import {
  cancelar,
  nuevo_viaje,
  si,
  vas_a_confirmar_el_viaje,
  viaje_registrado_con_exito,
  tienes_un_viaje_en_curso,
  en_cuanto_finalice_el_mismo_podras_solicitar_uno_nuevo,
  resumen_del_viaje,
  destino,
  partida,
  trayecto,
  resumen,
  confirmar,
  metodo_de_pago,
  falta_agregar_metodo_de_pago_valido,
  pago,
} from "../../../utils/traductor";
import { getrole } from "../../../utils/variablesLocales";
import { PartidaDestino } from "../../../componentes/NuevoViaje/PartidaDestino";
import { identity } from "lodash";
import Backdrop from "@mui/material/Backdrop";
import CircularProgress from "@mui/material/CircularProgress";
import animacion from "../../../imagenes/AnimacionesVarias/LoadingMap.json";
import { Player } from "@lottiefiles/react-lottie-player";

import { ButtonGroup } from "semantic-ui-react";
import { CheckCircleOutline, Margin } from "@mui/icons-material";
import Snackbar from "@mui/material/Snackbar";
import { Alert } from "@mui/material";

function ScrollTop(props) {
  const { children, window } = props;
  // Note that you normally won't need to set the window ref as useScrollTrigger
  // will default to window.
  // This is only being set here because the demo is in an iframe.
  const trigger = useScrollTrigger({
    target: window ? window() : undefined,
    disableHysteresis: true,
    threshold: 100,
  });

  const handleClick = (event) => {
    const anchor = (event.target.ownerDocument || document).querySelector(
      "#back-to-top-anchor"
    );

    if (anchor) {
      anchor.scrollIntoView({
        block: "center",
      });
    }
  };

  return (
    <Fade in={trigger}>
      <Box
        onClick={handleClick}
        role="presentation"
        sx={{ position: "fixed", bottom: 16, right: 16 }}
      >
        {children}
      </Box>
    </Fade>
  );
}

ScrollTop.propTypes = {
  children: PropTypes.element.isRequired,
  /**
   * Injected by the documentation to work in an iframe.
   * You won't need it on your project.
   */
  window: PropTypes.func,
};

const apimobbex = new apiMobbex();
const apisubastador = new apiSubastador();
const apiprecio = new apiPrecio();
const apiusuario = new apiUsuario();
// const apigeolocalizacion = new apiGeolocalizacion();
const apiviaje = new apiViaje();

export function NuevoViaje(props) {
  const [open, setOpen] = React.useState(false);
  const handleClose = () => {
    setOpen(false);
  };
  const handleOpen = () => {
    setOpen(true);
  };

  // const [EstaConectado, setEstaConectado] = useState(false);

  const navigate = useNavigate();

  const [ViajeEnCurso, setViajeEnCurso] = useState(0);

  const [PartidaUbicacion, setPartidaUbicacion] = useState("");
  const [DestinoUbicacion, setDestinoUbicacion] = useState("");

  const [Paso, setPaso] = useState(1);

  const [Localidad, setLocalidad] = useState(null);
  const [Provincia, setProvincia] = useState(null);
  const [Pais, setPais] = useState(null);

  const [LatitudPartida, setLatitudPartida] = useState(null);
  const [LongitudPartida, setLongitudPartida] = useState(null);

  const [LatitudPartidaGps, setLatitudPartidaGps] = useState(null);
  const [LongitudPartidaGps, setLongitudPartidaGps] = useState(null);

  const [LatitudPartidaIp, setLatitudPartidaIp] = useState(null);
  const [LongitudPartidaIp, setLongitudPartidaIp] = useState(null);

  const [LatitudDestinoGps, setLatitudDestinoGps] = useState(null);
  const [LongitudDestinoGps, setLongitudDestinoGps] = useState(null);

  const [LatitudDestinoIp, setLatitudDestinoIp] = useState(null);
  const [LongitudDestinoIp, setLongitudDestinoIp] = useState(null);

  const [LatitudDestino, setLatitudDestino] = useState(null);
  const [LongitudDestino, setLongitudDestino] = useState(null);

  const [Kms, setKms] = useState(0);
  const [Min, setMin] = useState(0);
  const [PrecioBase, setPrecioBase] = useState(0);

  const [Pasajero, setPasajero] = useState("");
  const [VerEnGoogleMaps, setVerEnGoogleMaps] = useState("");

  const PasoAtras = () => {
    if (Paso === 1) {
    } else {
      setPaso(Paso - 1);
    }
  };

  const PasoAdelante = () => {
    if (Paso === 5) {
    } else {
      setPaso(Paso + 1);
    }
  };

  const Confirmar = async () => {
    Swal.fire({
      title: vas_a_confirmar_el_viaje,
      text: "",
      // type: "confirm",
      showCancelButton: true,
      confirmButtonText: si,
      confirmButtonColor: estiloColores.Azul,
      cancelButtonText: cancelar,
      cancelButtonColor: estiloColores.Gris,
    }).then((result) => {
      if (result.value) {
        ConfirmarAccion();
      }
    });
  };

  const ConfirmarAccion = async () => {
    let PasajeroAux = getNombre() + " " + getApellido();
    setPasajero(PasajeroAux);

    let VerEnGoogleMapsAux =
      "https://www.google.com.ar/maps/dir/Calle+" +
      PartidaUbicacion.replace("  ", " ")
        .replace(" ", "+")
        .replace("á", "a")
        .replace("é", "e")
        .replace("í", "i")
        .replace("ó", "o")
        .replace("ú", "u")
        .replace("ñ", "n") +
      ",+" +
      Localidad.replace("  ", " ")
        .replace(" ", "+")
        .replace("á", "a")
        .replace("é", "e")
        .replace("í", "i")
        .replace("ó", "o")
        .replace("ú", "u")
        .replace("ñ", "n") +
      ",+" +
      Provincia.replace("  ", " ")
        .replace(" ", "+")
        .replace("á", "a")
        .replace("é", "e")
        .replace("í", "i")
        .replace("ó", "o")
        .replace("ú", "u")
        .replace("ñ", "n") +
      "/" +
      DestinoUbicacion.replace("  ", " ")
        .replace(" ", "+")
        .replace("á", "a")
        .replace("é", "e")
        .replace("í", "i")
        .replace("ó", "o")
        .replace("ú", "u")
        .replace("ñ", "n") +
      ",+" +
      Localidad.replace("  ", " ")
        .replace(" ", "+")
        .replace("á", "a")
        .replace("é", "e")
        .replace("í", "i")
        .replace("ó", "o")
        .replace("ú", "u")
        .replace("ñ", "n") +
      ",+" +
      Provincia.replace("  ", " ")
        .replace(" ", "+")
        .replace("á", "a")
        .replace("é", "e")
        .replace("í", "i")
        .replace("ó", "o")
        .replace("ú", "u")
        .replace("ñ", "n");

    setVerEnGoogleMaps(VerEnGoogleMapsAux);

    const respuestaViaje = await apiviaje.nuevo(
      PartidaUbicacion,
      LatitudPartida,
      LongitudPartida,
      DestinoUbicacion,
      LatitudDestino,
      LongitudDestino,
      Kms,
      Min,
      PrecioBase,
      Localidad,
      Provincia,
      PasajeroAux,
      VerEnGoogleMapsAux,
      getTokenNotificacion()
    );

    if (respuestaViaje._id !== undefined) {
      //muestro snackbar
      setMensajeInformacion(viaje_registrado_con_exito);
      setOpenInformacion(true);

      //muestro back-drop
      setOpen(true);

      setmenuAbajoSeleccionado("Inicio");
      setmenuLateralSeleccionado("");

      const ViajeId = respuestaViaje._id;

      //creo boton de pago
      await apimobbex.checkout(ViajeId, getIdioma());

      //solicito subasta
      await apisubastador.subastar(ViajeId);

      //pooling
      //setPoolingActivado(true);
      setViajeId(ViajeId);

      navigate(ENTORNO.URL_APLICACION + "/Pasajero/Inicio");
    }
  };

  useEffect(() => {
    (async () => {
      try {
        //controlando la seguridad para que solo acceda a esta pantalla el perfil que corresponda
        if (getrole() !== "Pasajero") {
          navigate(ENTORNO.URL_APLICACION + "/CerrarSesion");
        }

        // //verificar que no tenga ningún viaje PENDIENTE, PRECIO SUGERIDO
        // const respuesta = await apiviaje.obtenerPENDIENTE();
        // const respuesta1 = await apiviaje.obtenerPRECIO_SUGERIDO();

        // if (respuesta.length > 0 || respuesta1.length) {
        //   setViajeEnCurso(1);
        //   setPaso(0);
        // } else {
        //   setViajeEnCurso(0);
        //   setPaso(1);
        // }
        //////////////////////////////////////////////

        if (
          Kms !== undefined &&
          Kms !== null &&
          Kms !== "" &&
          parseInt(Kms) !== 0
        ) {
          //Obtengo el precio base
          if (
            Localidad !== null &&
            Localidad !== undefined &&
            Localidad !== "" &&
            Kms !== null &&
            Kms !== undefined &&
            parseInt(Kms) !== 0
          ) {
            let respuesta = await apiprecio.obtenerPrecioBase(Localidad, Kms);

            if (respuesta.Mensaje !== undefined && respuesta.Mensaje !== null) {
              if (respuesta.Mensaje === "El token ha expirado") {
                if (getemail() !== null) {
                  if (getpassword() !== null) {
                    await apiusuario.Ingresar(
                      getemail(),
                      getpassword(),
                      getIdioma()
                    );

                    respuesta = await apiprecio.obtenerPrecioBase(
                      Localidad,
                      Kms
                    );
                  }
                }
              }

              if (respuesta.Estado !== undefined && respuesta.Estado !== null) {
                if (respuesta.Estado === "Ok") {
                  setPrecioBase(respuesta.PrecioBase);

                  // const respuestaGeolocalizacionPartida =
                  //   await apigeolocalizacion.LatLonToAddress(
                  //     LatitudPartida,
                  //     LongitudPartida
                  //   );
                  // setPartidaUbicacion(respuestaGeolocalizacionPartida);

                  // const respuestaGeolocalizacionDestino =
                  //   await apigeolocalizacion.LatLonToAddress(
                  //     LatitudDestino,
                  //     LongitudDestino
                  //   );
                  // setDestinoUbicacion(respuestaGeolocalizacionDestino);
                }
              }
            } else {
              setPrecioBase(respuesta.PrecioBase);

              // const respuestaGeolocalizacionPartida1 =
              //   await apigeolocalizacion.LatLonToAddress(
              //     LatitudPartida,
              //     LongitudPartida
              //   );
              // setPartidaUbicacion(respuestaGeolocalizacionPartida1);

              // const respuestaGeolocalizacionDestino1 =
              //   await apigeolocalizacion.LatLonToAddress(
              //     LatitudDestino,
              //     LongitudDestino
              //   );
              // setDestinoUbicacion(respuestaGeolocalizacionDestino1);
            }
          }
        }
      } catch (error) {
        console.error(error);
      }
    })();
  });

  //////////////////////////////////////////////////////

  const navigateToInicio = async () => {
    navigate(ENTORNO.URL_APLICACION + "/Pasajero/Inicio");
  };

  ///////////////////////////////////
  //notificacion snackbar informacion de accion
  const [MensajeInformacion, setMensajeInformacion] = useState("");
  const [openInformacion, setOpenInformacion] = React.useState(false);

  // const handleCloseInformacion = (
  //   event: React.SyntheticEvent | Event,
  //   reason?: string
  // ) => {
  //   if (reason === "clickaway") {
  //     return;
  //   }

  //   setOpenInformacion(false);
  // };

  const handleCloseInformacion = (event, reason) => {
    if (reason === "clickaway") {
      return;
    }

    setOpenInformacion(false);
  };
  ///////////////////////////////////

  return (
    <div style={{ overfxlow: "hidden", touchAction: "none" }}>
      <div className="divPrincipal_NuevoViaje">
        {isMobile !== true ? (
          <DispositivoMovilNoDetectado></DispositivoMovilNoDetectado>
        ) : (
          <div>
            <React.Fragment>
              <CssBaseline />
              <AppBar style={{ background: "#DC030E" }}>
                <Toolbar>
                  <IconButton
                    size="large"
                    edge="start"
                    color="inherit"
                    onClick={navigateToInicio}
                    aria-label="menu"
                    sx={{ mr: 2 }}
                  >
                    <CloseIcon />
                  </IconButton>
                  <Typography variant="h6" component="div" sx={{ flexGrow: 1 }}>
                    {nuevo_viaje}
                  </Typography>
                </Toolbar>
              </AppBar>
              <Toolbar id="back-to-top-anchor" />
              <Container>
                <Box sx={{ my: 2 }}>
                  {/* <MenuArriba /> */}
                  <Segment style={estiloSegmento.Pasajero}>
                    <Form>
                      {ViajeEnCurso === 1 ? (
                        <div>
                          <Message icon color="blue">
                            <Icon name="circle notched" loading />
                            <Message.Content>
                              <Message.Header>
                                {tienes_un_viaje_en_curso}
                              </Message.Header>
                              {
                                en_cuanto_finalice_el_mismo_podras_solicitar_uno_nuevo
                              }
                            </Message.Content>
                          </Message>
                        </div>
                      ) : (
                        <div></div>
                      )}
                      {Paso === 1 ? (
                        <PartidaDestino
                          Modo="Partida"
                          Latitud={LatitudPartida}
                          setLatitud={setLatitudPartida}
                          Longitud={LongitudPartida}
                          setLongitud={setLongitudPartida}
                          Localidad={Localidad}
                          setLocalidad={setLocalidad}
                          Provincia={Provincia}
                          setProvincia={setProvincia}
                          Pais={Pais}
                          setPais={setPais}
                          LatitudGps={LatitudPartidaGps}
                          setLatitudGps={setLatitudPartidaGps}
                          LongitudGps={LongitudPartidaGps}
                          setLongitudGps={setLongitudPartidaGps}
                          LatitudIp={LatitudPartidaIp}
                          setLatitudIp={setLatitudPartidaIp}
                          LongitudIp={LongitudPartidaIp}
                          setLongitudIp={setLongitudPartidaIp}
                          Ubicacion={PartidaUbicacion}
                          setUbicacion={setPartidaUbicacion}
                        ></PartidaDestino>
                      ) : (
                        <></>
                      )}
                      {Paso === 2 ? (
                        <PartidaDestino
                          Modo="Destino"
                          Latitud={LatitudDestino}
                          setLatitud={setLatitudDestino}
                          Longitud={LongitudDestino}
                          setLongitud={setLongitudDestino}
                          Localidad={Localidad}
                          setLocalidad={setLocalidad}
                          Provincia={Provincia}
                          setProvincia={setProvincia}
                          Pais={Pais}
                          setPais={setPais}
                          LatitudGps={LatitudDestinoGps}
                          setLatitudGps={setLatitudDestinoGps}
                          LongitudGps={LongitudDestinoGps}
                          setLongitudGps={setLongitudDestinoGps}
                          LatitudIp={LatitudDestinoIp}
                          setLatitudIp={setLatitudDestinoIp}
                          LongitudIp={LongitudDestinoIp}
                          setLongitudIp={setLongitudDestinoIp}
                          Ubicacion={DestinoUbicacion}
                          setUbicacion={setDestinoUbicacion}
                        ></PartidaDestino>
                      ) : (
                        <></>
                      )}
                      {Paso === 3 ? (
                        <CalcularTrayecto
                          LatitudPartida={LatitudPartida}
                          setLatitudPartida={setLatitudPartida}
                          LongitudPartida={LongitudPartida}
                          setLongitudPartida={setLongitudPartida}
                          LatitudDestino={LatitudDestino}
                          setLatitudDestino={setLatitudDestino}
                          LongitudDestino={LongitudDestino}
                          setLongitudDestino={setLongitudDestino}
                          Localidad={Localidad}
                          Kms={Kms}
                          setKms={setKms}
                          Min={Min}
                          setMin={setMin}
                          PrecioBase={PrecioBase}
                          PartidaUbicacion={PartidaUbicacion}
                          setPartidaUbicacion={setPartidaUbicacion}
                          DestinoUbicacion={DestinoUbicacion}
                          setDestinoUbicacion={setDestinoUbicacion}
                        ></CalcularTrayecto>
                      ) : (
                        <></>
                      )}
                      {Paso === 4 ? (
                        <VerResumen
                          Titulo={resumen_del_viaje}
                          Localidad={Localidad}
                          Provincia={Provincia}
                          Pais={Pais}
                          PartidaUbicacion={PartidaUbicacion}
                          DestinoUbicacion={DestinoUbicacion}
                          Kms={Kms}
                          Min={Min}
                          PrecioBase={PrecioBase}
                        ></VerResumen>
                      ) : (
                        <></>
                      )}
                      {Paso === 5 ? (
                        <MetodoPago
                          Titulo={resumen_del_viaje}
                          Localidad={Localidad}
                          Provincia={Provincia}
                          Pais={Pais}
                          PartidaUbicacion={PartidaUbicacion}
                          DestinoUbicacion={DestinoUbicacion}
                          Kms={Kms}
                          Min={Min}
                          PrecioBase={PrecioBase}
                        ></MetodoPago>
                      ) : (
                        <></>
                      )}
                    </Form>
                  </Segment>
                  {/* <BarraNavegacionyMenuLateral /> */}
                </Box>
              </Container>

              <ScrollTop {...props}>
                <Fab size="small" aria-label="scroll back to top">
                  <KeyboardArrowUpIcon />
                </Fab>
              </ScrollTop>

              <AppBar
                position="fixed"
                color="primary"
                sx={{ top: "auto", bottom: 0 }}
              >
                {Paso === 1 ? (
                  <div>
                    {LatitudPartida === undefined ||
                    LatitudPartida === null ||
                    LatitudPartida === "" ? (
                      <div></div>
                    ) : (
                      <Toolbar
                        style={{ background: "#153B5E", color: "white" }}
                      >
                        <Box sx={{ flexGrow: 1 }} />
                        <IconButton color="inherit" onClick={PasoAdelante}>
                          {destino}
                        </IconButton>
                        <Box sx={{ flexGrow: 1 }} />
                      </Toolbar>
                    )}
                  </div>
                ) : (
                  <></>
                )}

                {Paso === 2 ? (
                  <div>
                    {LatitudPartida === undefined ||
                    LatitudPartida === null ||
                    LatitudPartida === "" ||
                    LatitudDestino === undefined ||
                    LatitudDestino === null ||
                    LatitudDestino === "" ? (
                      <div>
                        <Toolbar
                          style={{ background: "#153B5E", color: "white" }}
                        >
                          <Box sx={{ flexGrow: 1 }} />
                          <IconButton color="inherit" onClick={PasoAtras}>
                            {partida}
                          </IconButton>
                          <Box sx={{ flexGrow: 1 }} />
                        </Toolbar>
                      </div>
                    ) : (
                      <div>
                        <Toolbar
                          style={{ background: "#153B5E", color: "white" }}
                        >
                          <Box sx={{ flexGrow: 1 }} />
                          <IconButton color="inherit" onClick={PasoAtras}>
                            {partida}
                          </IconButton>
                          <Box sx={{ flexGrow: 1 }} />
                          <IconButton color="inherit" onClick={PasoAdelante}>
                            {trayecto}
                          </IconButton>
                          <Box sx={{ flexGrow: 1 }} />
                        </Toolbar>
                      </div>
                    )}
                  </div>
                ) : (
                  <></>
                )}

                {Paso === 3 ? (
                  <div>
                    <Toolbar style={{ background: "#153B5E", color: "white" }}>
                      <Box sx={{ flexGrow: 1 }} />
                      <IconButton color="inherit" onClick={PasoAtras}>
                        {destino}
                      </IconButton>
                      <Box sx={{ flexGrow: 1 }} />
                      <IconButton color="inherit" onClick={PasoAdelante}>
                        {resumen}
                      </IconButton>
                      <Box sx={{ flexGrow: 1 }} />
                    </Toolbar>
                  </div>
                ) : (
                  <></>
                )}

                {Paso === 4 ? (
                  <div>
                    <Toolbar style={{ background: "#153B5E", color: "white" }}>
                      <Box sx={{ flexGrow: 1 }} />
                      <IconButton color="inherit" onClick={PasoAtras}>
                        {trayecto}
                      </IconButton>
                      <Box sx={{ flexGrow: 1 }} />
                      <IconButton color="inherit" onClick={Confirmar}>
                        {confirmar}
                      </IconButton>
                      <Box sx={{ flexGrow: 1 }} />
                    </Toolbar>
                  </div>
                ) : (
                  <></>
                )}
              </AppBar>
            </React.Fragment>
          </div>
        )}
      </div>

      <Backdrop
        sx={{ color: "#fff", zIndex: (theme) => theme.zIndex.drawer + 1 }}
        open={open}
        onClick={handleClose}
      >
        <Player
          src={animacion}
          className="player"
          loop
          autoplay
          style={{ height: 110 }}
        />
      </Backdrop>

      <Snackbar
        open={openInformacion}
        onClose={handleCloseInformacion}
        autoHideDuration={3000}
        anchorOrigin={{ vertical: "top", horizontal: "center" }}
      >
        <Alert
          icon={<CheckCircleOutline fontSize="inherit" />}
          severity="success"
          variant="filled"
          sx={{ width: "100%" }}
        >
          {MensajeInformacion}
        </Alert>
      </Snackbar>
    </div>
  );
}
